/**
 * Agent registry — maps agent IDs to their config writers.
 */

import type { AgentConfigWriter } from "./base.js";
import { claudeCode } from "./claude-code.js";
import { cursor } from "./cursor.js";
import { codex } from "./codex.js";
import { copilot } from "./copilot.js";
import { opencode } from "./opencode.js";
import { windsurf } from "./windsurf.js";
import { gemini } from "./gemini.js";
import { goose } from "./goose.js";
import { generic } from "./generic.js";

export const agents: Record<string, AgentConfigWriter> = {
  "claude-code": claudeCode,
  cursor,
  codex,
  copilot,
  opencode,
  windsurf,
  gemini,
  goose,
  generic,
};

export function getAgent(id: string): AgentConfigWriter | undefined {
  return agents[id];
}

export function getAllAgents(): AgentConfigWriter[] {
  return Object.values(agents);
}

export { type AgentConfigWriter } from "./base.js";
